export const OPENSEA_LOGO_URL =
  "https://raw2.seadn.io/app_logos/opensea-logo.svg"

export const TRUST_WALLET_LOGO_URL = "/img/wallet-logos/trust-wallet.svg"
export const METAMASK_LOGO_URL = "/img/wallet-logos/metamask.svg"
export const ZERION_LOGO_URL = "/img/wallet-logos/zerion.svg"
export const PHANTOM_LOGO_URL = "/img/wallet-logos/phantom.svg"
export const CORE_LOGO_URL = "/img/wallet-logos/core.svg"
export const RABBY_LOGO_URL = "/img/wallet-logos/rabby.svg"
export const SOLFLARE_LOGO_URL = "/img/wallet-logos/solflare.jpg"
